// extracted by mini-css-extract-plugin
export default {"button":"_1Wjc","button_big":"_1JOm","button_text":"bm6g","button_spinner_container":"_1gyf","itemized_details_container":"_3GbY"};